import { RequireAuth } from "@/components/RequireAuth";
import { createFileRoute } from "@tanstack/react-router";
import { ServerLocationWizard } from "../pages";

export const Route = createFileRoute("/server-location-wizard")({
  component: () => (
    <RequireAuth>
      <ServerLocationWizard />
    </RequireAuth>
  ),
});
